import { ProjectContact } from "pmt-types/src/models/ProjectContact.ts";
import { useMutationSearchEntities } from "./useMutationSearchEntities.ts";

export const useMutationSearchProjectContacts = () =>
  useMutationSearchEntities<ProjectContact>("projectContacts");
